import { Card, CardContent, CardHeader, CardTitle, Truck } from '@chain-zen/ui'

import { ShipmentCreatedViaEnum } from '../../../../../types/shipment'
import AddStopContainer from './add-stop-container'
import { useStops } from './contexts/use-stops-context'
import { StopsList } from './stops-list'

/*
 * This component is used to render the stops section in the shipment details page
 */
export const Stops = () => {
  const { shipment, stops } = useStops()
  const canEditStops = shipment.isShipmentOwner && shipment.createdVia !== ShipmentCreatedViaEnum.Integration
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Truck className="h-4 w-4 text-primary" />
          Stops
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div>
          {!!stops && <StopsList stops={stops} />}
          {!!canEditStops && (
            <div className={stops.length > 0 ? 'mt-4' : ''}>
              <AddStopContainer />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
